import React, { Component } from 'react';
import moment from 'moment';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Form, FormGroup, Radio } from 'react-bootstrap';
import { Link } from 'react-router';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import BlitzAPI from '../../api/BlitzAPI';
import TableDatetimeEditor from '../form/TableDatetimeEditor';
import { ENTRY_TABLE_TYPE_OPTIONS, ESPORT_TABLE_TYPE_OPTIONS, ESPORT_TYPE_OPTIONS } from '../form/constants';
import { typeDataFormat, esportDataFormat } from './TableUtils';
import { getSourceOptions } from '../../utils';
import './EntryListTable.css';

function createTableDateTimeEditor(onUpdate, props) {
  return <TableDatetimeEditor onUpdate={onUpdate} {...props} />;
}

function entryDataFormat(cell, row) {
  const entryLink = `/entries/external/${cell}`;

  return (
    <Link to={entryLink}>
      <div>
        {cell}
      </div>
    </Link>
  );
}

function titleDataFormat(cell, row) {
  const entryLink = `/entries/external/${row.id}`;

  return (
    <Link to={entryLink}>{cell}</Link>
  );
}

function sourceDataFormat(cell) {
  if (cell) {
    return cell.name;
  }
  return null;
}

function datetimeDataFormat(cell, row) {
  return moment(row.publish_date).format('MMM Do[,] YYYY h:mma');
}

function linkDataFormat(cell, row) {
  return (
    <a href={row.url} target="_blank" rel="noopener noreferrer" className="entry-item-preview">Link</a>
  );
}

function trStyleFormat(row) {
  let outClass = 'entry-table-item ';
  if (!row.published) {
    outClass += 'entry-table-draft';
  }
  return outClass;
}

export default class EntryListTableExternal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      sources: null,
      query: { is_blitz: 'false', type: 'article,youtube,feed' },
      type: 'article,youtube,feed',
      is_blitz: 'true',
      published: '',
      esport: '',
      search: '',
    };
    this.onCellEdit = this.onCellEdit.bind(this);
    this.getData = this.getData.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  componentDidMount() {
    BlitzAPI.getSources().then(
      (response) => {
        const sourceOptions = getSourceOptions(response);
        this.setState(
          {
            sources: sourceOptions,
          },
        );
      },
    );
    this.getData();
  }

  onCellEdit(row, fieldName, value) {
    const { data } = this.state;
    let rowIndex;
    const targetRow = data.find(
      (currentRow, index) => {
        if (currentRow.id === row.id) {
          rowIndex = index;
          return true;
        }
        return false;
      },
    );

    if (targetRow && targetRow[fieldName] !== value) {
      targetRow[fieldName] = value;
      data[rowIndex] = targetRow;
      const entryParams = {};
      entryParams[fieldName] = value;
      BlitzAPI.patchEntry(row.id, { entry: entryParams }).then(
        response => console.log(response),
      );
      this.setState({ data });
    }
  }

  onPageChange(page, sizePerPage) {
    const query = Object.assign({}, this.state.query, { page });
    this.setState({ query }, this.getData);
  }

  onSortChange(sortName, sortOrder) {
    const sorting = sortOrder === 'asc' ? sortName : `-${sortName}`;
    const query = Object.assign({}, this.state.query, { order_by: sorting });
    this.setState({
      query,
    }, this.getData);
  }

  onTypeChange(e) {
    const { value } = e.target;

    const query = Object.assign({}, this.state.query, { type: value });
    this.setState({ query, type: value }, this.getData);
  }

  onRadioChange(e, field) {
    const { value } = e.target;
    const { query } = this.state;
    let newQuery;
    switch (value) {
      case 'true':
        newQuery = Object.assign({}, query, { [field]: true });
        break;
      case 'false':
        newQuery = Object.assign({}, query, { [field]: false });
        break;
      case '':
        newQuery = Object.assign({}, query);
        delete newQuery[field];
        break;
      default:
        newQuery = Object.assign({}, query, { [field]: value });
    }
    this.setState({ [field]: value });
    this.setState({ query: newQuery }, this.getData);
  }

  onSearchChange(e) {
    this.setState({ search: e.target.value });
    let { query } = this.state;
    if (!e.target.value) {
      delete query.search;
    } else {
      query = Object.assign({}, query, { search: e.target.value });
    }
    this.setState({ query }, this.getData);
  }

  getData() {
    BlitzAPI.getEntries(this.state.query).then(
      (resp) => {
        return this.setState({
          data: resp.data.data,
          sizePerPage: resp.data.page_size,
          dataTotalSize: resp.data.total_entries,
          currentPage: resp.data.page_number,
        });
      },
    );
  }

  render() {
    const { esport, type, search } = this.state;

    return (
      this.state.data && this.state.sources ?
        <div>
          <div className="container entry-filter entry-filter-external">
            <div className="entry-filter-search">
              <input value={search} onChange={this.onSearchChange} placeholder="Search" />
            </div>
            <Form horizontal>
              <div className="entry-filter-item entry-filter-type">
                <FormGroup>
                  <Radio onChange={this.onTypeChange} value="article,youtube,feed" checked={type === 'article,youtube,feed'}><span>All Content</span></Radio>
                  <Radio onChange={this.onTypeChange} value="article" checked={type === 'article'}><span>Articles</span></Radio>
                  <Radio onChange={this.onTypeChange} value="youtube" checked={type === 'youtube'}><span>Youtube</span></Radio>
                  <Radio onChange={this.onTypeChange} value="feed" checked={type === 'feed'}><span>BlitzFeed</span></Radio>
                </FormGroup>
              </div>
              <div className="entry-filter-item entry-filter-esport">
                <FormGroup>
                  {ESPORT_TYPE_OPTIONS.map((game, idx) =>
                    <Radio
                      onChange={e => this.onRadioChange(e, 'esport')}
                      value={game[0]}
                      checked={esport === game[0]} // eslint-disable-line camelcase
                    ><span>{game[1]}</span></Radio>,
                  )}
                </FormGroup>
              </div>
            </Form>
          </div>
          <div>
            <BootstrapTable
              data={this.state.data}
              remote hover
              pagination
              trClassName={trStyleFormat}
              fetchInfo={{ dataTotalSize: this.state.dataTotalSize }}
              options={{
                onSortChange: this.onSortChange,
                sizePerPage: this.state.sizePerPage,
                onPageChange: this.onPageChange,
                page: this.state.currentPage,
              }}
            >

              <TableHeaderColumn
                dataField="esport"
                dataFormat={esportDataFormat}
                width="60"
                editable={{ type: 'select', options: { values: ESPORT_TABLE_TYPE_OPTIONS } }}
              >Esport</TableHeaderColumn>
              <TableHeaderColumn
                dataField="type"
                width="70"
                dataFormat={typeDataFormat}
                dataSort
                editable={{ type: 'select', options: { values: ENTRY_TABLE_TYPE_OPTIONS } }}
              >Type</TableHeaderColumn>
              <TableHeaderColumn dataField="title" dataFormat={titleDataFormat} dataSort>Title</TableHeaderColumn>
              <TableHeaderColumn
                dataField="source"
                editable={false}
                dataFormat={sourceDataFormat}
                width="132"
              >Source</TableHeaderColumn>
              <TableHeaderColumn
                dataField="publish_date"
                width="192"
                dataSort
                dataFormat={datetimeDataFormat}
                customEditor={{ getElement: createTableDateTimeEditor }}
                editColumnClassName="table-datetime-editor"
              >Publish Date</TableHeaderColumn>
              <TableHeaderColumn
                isKey
                dataField="id"
                width="70"
                dataFormat={entryDataFormat}
                dataSort
              >ID</TableHeaderColumn>
              <TableHeaderColumn dataField="preview" width="0" dataFormat={linkDataFormat} >Link</TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div> : <div><h1>Loading</h1></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/entry/EntryListTableExternal.js